<template>
  <main class="pagen-end">
      <a href="https://beian.miit.gov.cn" target="_blank">鲁ICP备2023035299号-1</a>
  </main>
</template>


<script>

export default {
  name: "PageEnd",
  data() {
    // Set initial data, this.createMap() configures event listeners that update data based on user interaction
    return {};
  },
  mounted() {
  }
}
</script>

<style scoped>
.page-end {
  height: auto;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  color: blue;
}

</style>